// Configure AuthContext for Treasurer app
import { AuthProvider as SharedAuthProvider } from '@masonic-tools/shared-auth';
import { auth, db } from '@/lib/firebase';
import { showError, showSuccess } from '@/lib/swal';

export { useAuth } from '@masonic-tools/shared-auth';

export function AuthProvider({ children }: { children: React.ReactNode }) {
  // No need for emailVerificationBaseUrl anymore!
  // Now using Firebase Callable Functions - much simpler, no CORS issues
  return (
    <SharedAuthProvider
      auth={auth}
      db={db}
      onSuccess={showSuccess}
      onError={showError}
    >
      {children}
    </SharedAuthProvider>
  );
}

